import React, {Component} from 'react';
import {AJAX, hidePreloader, showPreloader, setUrlSinglePageApp} from "../functions";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import WrapperContentFromArticleForPopup from "../common/WrapperContentFromArticleForPopup";
import {showPopupNoteArticle} from "../popups/PopupNoteArticle";
import {withRouter} from "react-router";

class FindMyVehiclePage extends Component {
    state = {
        markers: [],
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
        display_btn: false,
        note: ''
    };

    constructor(props) {
        super(props);
        this.handleSetPage({name: 'find_my_vehicle', params: false});
        this.getVehiclePosition = this.getVehiclePosition.bind(this);
        this.showDetails = this.showDetails.bind(this);
        this.state.height -= 410;

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        this.props.handleSetPage(options);
    }

    handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(browserHasGeolocation ?
            (
                typeof browserHasGeolocation === 'string' ?
                browserHasGeolocation : 'Error: The Geolocation service failed.'
            )
             :'Error: Your browser doesn\'t support geolocation.');
        infoWindow.open(map);
    }

    createMarkerForPoint(point, map, displayIcon) {
        let marker = {
            position: new google.maps.LatLng(point.lat, point.lng),
            map: map
        };

        if (displayIcon) {
            marker.icon = bm_ajax_url + '?action=api/booking/get_marker_for_map'
        }

        return new google.maps.Marker(marker);
    }

    createBoundsForMarkers(markers) {
        let bounds = new google.maps.LatLngBounds();
        markers.forEach(el => bounds.extend(el.getPosition()));
        return bounds;
    }

    getBoundsZoomLevel(bounds, mapDim) {
        let WORLD_DIM = {height: 320, width: 320};
        let ZOOM_MAX = 21;

        function latRad(lat) {
            let sin = Math.sin(lat * Math.PI / 180);
            let radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }

        let ne = bounds.getNorthEast();
        let sw = bounds.getSouthWest();

        let latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

        let lngDiff = ne.lng() - sw.lng();
        let lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

        let latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
        let lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    initMap(coordinates) {
        let t = this,
            markers = this.state.markers,
            bounds,
            _gmap = document.getElementById('gmap_vehicle');

        if (!_gmap)
            return;

        let mapDim = {
            height: _gmap.clientHeight,
            width: _gmap.clientWidth
        };

        window.map = new google.maps.Map(_gmap, {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            scaleControl: true,
            rotateControl: true,
            zoomControl: true,
        });

        markers.push(t.createMarkerForPoint(coordinates, map, true));
        t.setState({markers: markers});
        bounds = t.state.markers.length > 0 ? t.createBoundsForMarkers(markers) : null;

        map.fitBounds(bounds);
        let listener = google.maps.event.addListener(map, "idle", function () {
            map.setZoom(12);
            google.maps.event.removeListener(listener);
        });

        setTimeout(function () {
            let infoWindow = new google.maps.InfoWindow();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    let pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    markers.push(t.createMarkerForPoint(pos, map));
                    t.setState({markers: markers});
                    infoWindow.setContent('YOU ARE HERE');
                    infoWindow.setPosition(pos);
                    infoWindow.open(map);
                    bounds = markers.length > 0 ? t.createBoundsForMarkers(markers) : null;
                    map.setZoom((bounds) ? t.getBoundsZoomLevel(bounds, mapDim) : 0);
                }, function (error) {
                    let text = true;
                    switch(error.code) {
                        case error.PERMISSION_DENIED:
                            text = "User denied the request for Geolocation.";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            text = "Location information is unavailable.";
                            break;
                        case error.TIMEOUT:
                            text = "The request to get user location timed out.";
                            break;
                        case error.UNKNOWN_ERROR:
                            text = "An unknown error occurred.";
                            break;
                    }
                    t.handleLocationError(text, infoWindow, map.getCenter());
                });
            } else {
                t.handleLocationError(false, infoWindow, map.getCenter());
            }
        }, 500);

    }

    getLinkToGoogleMapWithPoints() {
        let link = "https://www.google.com/maps/dir/?api=1";
        let countPount = this.state.markers.length;
        if (countPount > 0) {
          link += '&origin='
          if (countPount > 1 ) {
            link += this.state.markers[countPount - 1].position.lat() + ',' + this.state.markers[countPount - 1].position.lng();
          }
          link += '&destination=' + this.state.markers[0].position.lat() + ',' + this.state.markers[0].position.lng();
          link += '&dir_action=navigate';
        }
        return link;
    }

    getVehiclePosition() {
        let params = {
            session_key: this.props.session_key,
            action: 'api/booking/get_last_vehicle_position'
        };
        let t = this;
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                hidePreloader();
                if (!!document.getElementById('gmap_vehicle')) {
                    if (resp.success === 1) {
                        let coord = {
                            lat: resp.data.vehicle_coordinates.Latitude,
                            lng: resp.data.vehicle_coordinates.Longitude
                        };
                        t.initMap(coord);
                        t.setState({display_btn: true})
                        if (resp.data.hasOwnProperty('location_note') && resp.data.location_note) {
                            t.setState({note: resp.data.location_note}, t.showDetails);
                        }
                    } else {
                        if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                            showPopupWithGoBack(resp.errors.main);
                        }
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });

    }

    showDetails() {
        return showPopupNoteArticle(<WrapperContentFromArticleForPopup note={this.state.note} />)
    }

    render() {
        return (<div className="map-page">
            <div className="row">
                <div className="offset-1 col-10">
                    <div className="map-wrap" style={{height: (this.state.height + 'px')}}>
                        <div id="gmap_vehicle" style={{width: "100%", height: '100%'}}/>
                    </div>
                </div>
            </div>
            <div className="container d-flex justify-content-around align-items-center">
                {
                    this.state.note ? (
                        <button className="btn-fmv"
                                onClick={this.showDetails}
                        >
                            DETAILED NOTES
                        </button>
                    ) : null
                }
                {
                    this.state.display_btn ? (
                        <a href={this.getLinkToGoogleMapWithPoints()} id="need_direction_btn" className="btn-fmv" target="_blank">
                            NEED DIRECTIONS?
                        </a>
                    ) : null
                }
            </div>
            <div className="container text-center mt-2">
                <button type="button" className='go-btn go-back' onClick={()=>window.history.back()}/>
            </div>
            {/*<div className="row text-center">
                <div className="col-6">
                </div>
                <div className="col-6">

                </div>
            </div>*/}
            {/*{
                this.state.note ? (
                    <div className="container mt-1 mb-2" dangerouslySetInnerHTML={{__html:this.state.note}} />
                ) : null
            }*/}
        </div>);
    }

    componentDidMount() {
        this.getVehiclePosition();
    }
}

const FindMyVehiclePageR = withRouter(FindMyVehiclePage);
export default FindMyVehiclePageR;
